/**
 * Load Plausible on production hostname only (no cookies, GDPR-friendly).
 * Call once from main.tsx before render.
 */
export function loadPlausibleAnalytics() {
  if (typeof window === 'undefined') return;
  const enable = import.meta.env.VITE_ENABLE_ANALYTICS === 'true';
  const hostOk = window.location.hostname === 'app.johnicorn.dev';
  if (!enable && !hostOk) return;
  if (document.querySelector('script[data-domain="app.johnicorn.dev"]')) return;

  const s = document.createElement('script');
  s.defer = true;
  s.setAttribute('data-domain', 'app.johnicorn.dev');
  s.src = 'https://plausible.io/js/script.js';
  document.head.appendChild(s);
}
